import { Input } from "antd";
import { CopyClipBoard } from "assets/icons";
import Button from "components/BaseWidgets/button";
import "./style.scss";
import AlertNotification from "components/CustomWidgets/alertNotification";

function CopyInput({ value, className, color }) {
  const handleCopy = async (code) => {
    try {
      // Try using modern Clipboard API
      await navigator.clipboard.writeText(code);
      AlertNotification("success", "Copied to clipboard!");
    } catch (error) {
      console.error("Clipboard API failed, using fallback", error);

      // Fallback for non-HTTPS or restricted browsers
      const textArea = document.createElement("textarea");
      textArea.value = code;
      textArea.style.position = "fixed"; // Prevent scrolling to bottom
      textArea.style.opacity = "0"; // Hide the element
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        AlertNotification("success", "Copied to clipboard!");
      } catch (err) {
        AlertNotification("error", "Failed to copy");
      }
      document.body.removeChild(textArea);
    }
  };

  return (
    <Input
      style={{ "--input-color": color }}
      readOnly
      value={value}
      className={className}
      addonAfter={
        <Button onClick={() => handleCopy(value)} height={64} variant="custom">
          <CopyClipBoard />
        </Button>
      }
    />
  );
}

export default CopyInput;
